<app-project-info-header [projectStatus]="projectStatus"
    (updateProjectVerificationStatus)="UpdateVerificationCompleteStatus($event)"
    [isSaveResponseChanged]="isSaveResponses" [isClearResponseChanged]="isClearResponses"
    [pendingStores]="pendingStores" [reviewedStores]="reviewedStores" [vendorId]="vendorId"></app-project-info-header>

<section class="mt-131">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card border-0 stepsBars-2">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3 w-19per border-right-solid" id="divTreeview">
                                <p-tree #treeComponent [value]="projectFilesStoresTreeNode" selectionMode="single"
                                    [filter]="true" filterPlaceholder="Search Store" [styleClass]="'p-tree-wrapper'"
                                    [virtualScroll]="true" [virtualScrollItemSize]="46" [(selection)]="selectedNode"
                                    (onNodeSelect)="nodeSelect($event, true)" (onFilter)="handleFilter($event)"
                                    [filterBy]="'storeLabel'">

                                    <ng-template let-node pTemplate="default">
                                        <!-- Check if the node is a parent or a leaf (child) -->
                                        <ng-container *ngIf="!node.leaf; else leafNode">
                                            <!-- Child node (non-leaf) without arrow icon -->
                                            <div class="d-flex justify-content-between align-items-center"
                                                [ngClass]="{'disabled-container': node.data.isStoreValidated && IsSkipImagesByValidationResponse}">
                                                <div class="storeNameDiv">
                                                    <span class="mb-0 fs-13">{{ node.data.storeLabel }}</span>
                                                </div>
                                                <div class="storeStatusDiv">
                                                    <img [src]="node.data.isStoreValidated ? 'assets/images/green_tickmark.svg' : 'assets/images/progress_icon.svg'"
                                                        alt="">
                                                </div>
                                            </div>
                                        </ng-container>

                                        <ng-template #leafNode>
                                            <!-- Parent node (leaf)  -->
                                            <span class="leaf-node" title="{{node.data.filePath}}"
                                                style="font-weight: 700;">{{ node.label }}</span>
                                        </ng-template>
                                    </ng-template>
                                </p-tree>
                            </div>
                            <div class="col-md-9 w-84per ps-50px" id="divCarouselView"
                                [ngClass]="{'fullscreen-carousel': isFullScreen}">
                                <div class="row mb-2">
                                    <div class="col-md-5">
                                        <span class="statusHeading text-uppercase" *ngIf="!isAllStoresValidated">STORE :
                                        </span>
                                        <span class="statusValue "
                                            *ngIf="!isAllStoresValidated">{{selectedStoreName}}</span>&nbsp;&nbsp;&nbsp;
                                        <!-- <span class="statusHeading text-uppercase">IMAGE ID : </span>
                                        <span class="statusValue ">{{selectedImageId}}</span>&nbsp; -->
                                        <span class="statusHeading text-uppercase" *ngIf="!isAllStoresValidated">REPORT
                                            DATE : </span>
                                        <span class="statusValue "
                                            *ngIf="!isAllStoresValidated">{{selectedReportDate}}</span>
                                    </div>
                                    <div class="col-md-3 text-end">
                                        <input class="form-check-input" type="checkbox" id="chkSkipImages"
                                            (change)="skipImages($event)" [checked]="IsSkipImagesByValidationResponse"
                                            [(ngModel)]="IsSkipImagesByValidationResponse">
                                        <label class="form-check-label text-capitalize fs-14" for="chkSkipImages">
                                            SKIP IMAGES WITH RESPONSE
                                        </label>
                                    </div>
                                    <div class="col-md-4 text-end" *ngIf="!isFullScreen">
                                        <button type="button" class="btn btn-outline-dark_1 sliderBtn"
                                            (click)="openImageInNewTab()" title="Expand to Full Screen"
                                            [disabled]="isAllStoresValidated">
                                            <i class="fa-solid fa-expand"></i>
                                        </button>
                                    </div>
                                    <div class="col-md-4 text-end" *ngIf="isFullScreen">
                                        <button type="button" class="btn btn-outline-dark_1 sliderBtn"
                                            (click)="exitFullScreen()" title="Exit Full Screen">
                                            <i class="fa-solid fa-compress"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-8 position-relative">
                                        <div class="countSection" *ngIf="!isAllStoresValidated">
                                            <button type="button" class="btn countSecBtn"
                                                *ngIf="IsShowCountButton">{{currentImageIndex +
                                                1}}/{{totalImagesByStore}}</button>
                                        </div>
                                        <div id="imageNavigator" [ngClass]="{
                                            'carousel-container-fs': isFullScreen, 
                                            'carousel-container': !isFullScreen
                                        }">
                                            <button [ngClass]="{
                                                'carousel-control-prevBtn-fs': isFullScreen, 
                                                'carousel-control-prevBtn': !isFullScreen, 
                                                'disable-navigators-prev': !showPrevNavigator
                                            }" (click)="navigatePrevious()" [disabled]="!showPrevNavigator">
                                                <span class="carousel-control-prev-icon"></span>
                                            </button>

                                            <div class="border-1 surface-border border-round m-2 p-3 pt-0 mt-0"
                                                [ngClass]="isFullScreen ? 'custom-height-fs' : 'custom-height'">
                                                <div class="mb-3">
                                                    <div class="relative mx-auto"
                                                        [ngClass]="{'carousel-imagediv-fs': isFullScreen}">
                                                        <img [src]="lstImages[currentImageIndex]?.imageURL"
                                                            [alt]="lstImages[currentImageIndex]?.imageID"
                                                            class="w-full border-round"
                                                            [ngClass]="{'carousel-image-fs': isFullScreen, 'width: -webkit-fill-available; height: fit-content;': !isFullScreen}"
                                                            (error)="lstImages[currentImageIndex].imageURL = null"
                                                            *ngIf="lstImages[currentImageIndex]?.imageURL; else noImageTemplate">
                                                    </div>
                                                </div>
                                            </div>
                                            <button [ngClass]="{
                                                'carousel-control-nextBtn-fs': isFullScreen, 
                                                'carousel-control-nextBtn': !isFullScreen, 
                                                'disable-navigators-next': !showNextNavigator
                                            }" (click)="navigateNext()"
                                                [disabled]="isAllStoresValidated || !showNextNavigator">
                                                <span class="carousel-control-next-icon"></span>
                                            </button>
                                            <ng-template #noImageTemplate>
                                                <div style="width: 100%; text-align: center;">
                                                    <img src="assets/images/noimage.png" alt="No Image">
                                                </div>
                                            </ng-template>
                                        </div>
                                        <div class="actionBtns">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <app-project-validation-criteria-response [imageID]="selectedImageId"
                                            [projectID]="projectId" [projectStatus]="projectStatus" [isFullScreen]="isFullScreen"
                                            (saveCompleted)="onSaveValidationCriteriaReponsesCompleted()"
                                            (clearCompleted)="onClearValidationCriteriaReponsesCompleted()"
                                            *ngIf="!isAllStoresValidated && selectedImageId > 0"></app-project-validation-criteria-response>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<p-confirmDialog position="top" [baseZIndex]="200000" appendTo="body" role="alertdialog"></p-confirmDialog>